import axios from "@/axios";

export const CaseCreationStore = {
    namespaced: true,

    state: {
        riskScoreData: null,
        isRiskScoreModalShown: false,
        isCaseDueDateModalShown: false,
        riskLabelOptions: [],
        caseDueDateData: null,
        entityDueDateData: null,
        currentPopupFormData: null,
    },

    mutations: {
        SET_RISK_SCORE_DATA(state, payload) {
            state.riskScoreData = payload;
        },
        SET_RISK_SCORE_MODAL_SHOWN(state) {
            state.isRiskScoreModalShown = !state.isRiskScoreModalShown;
        },
        SET_RISK_OPTIONS(state, payload = []) {
            state.riskLabelOptions = payload;
        },
        SET_CASE_DUE_DATE_DATA(state, payload) {
            state.caseDueDateData = payload;
        },
        SET_ENTITY_DUE_DATE_DATA(state, payload) {
            state.entityDueDateData = payload;
        },
        SET_CASE_DUE_MODAL_SHOWN(state) {
            state.isCaseDueDateModalShown = !state.isCaseDueDateModalShown;
        },
        SET_CURRENT_POPUP_FORM_DATA(state, payload = null) {
            state.currentPopupFormData = payload;
        },
    },

    getters: {
        getRiskScoreData: state => state.riskScoreData,
        getIsRiskScoreModalShown: state => state.isRiskScoreModalShown,
        getIsCaseDueDateModalShown: state => state.isCaseDueDateModalShown,
        getRiskLabelOptions: state => state.riskLabelOptions,
        getCaseDueDateData: state => state.caseDueDateData,
        getEntityDueDateData: state => state.entityDueDateData,
        getCurrentPopupFormData: state => state.currentPopupFormData,
    },

    actions: {
        fetchRiskScore: async({ commit }, payload) => {
            const { case_id, params = {} } = payload;

            try {
                const { data } = await axios.get(`risk-assessment/case/${case_id}`, {
                    params,
                });
                commit('SET_RISK_SCORE_DATA', data);
            } catch (error) {
                console.log("error>>>", error);
            }
        },

        toggleRiskScoreModal: ({ commit }) => {
            commit("SET_RISK_SCORE_MODAL_SHOWN");
        },

        toggleCaseDueDateModal: ({ commit }) => {
            commit("SET_CASE_DUE_MODAL_SHOWN");
        },

        fetchRiskLabelOptions: async({ commit }, payload) => {
            const { case_id } = payload;

            try {
                const { data } = await axios.get(`risk-assessment/case/${case_id}/labels`);
                data.sort((a, b) => a.name.localeCompare(b.name));
                commit('SET_RISK_OPTIONS', data);
                return data;
            } catch (error) {
                console.log("error>>>", error);
            }
        },

        // TODO check params in the url and payload
        setRiskLabel: async(_, payload) => {
            const { case_id, label_id, reason } = payload;

            try {
                const { data } = await axios.post(`risk-assessment/case/${case_id}/label`, {
                    case_id,
                    label_id,
                    reason,
                });
                return data;
            } catch (error) {
                console.log("error>>>", error);
                throw error; // handle it outside
            }
        },

        // TODO check params in the url and payload
        deleteRiskLabel: async(_, payload) => {
            const { case_id, label_id } = payload;

            try {
                const { data } = await axios.delete(`risk-assessment/case/${case_id}/label`, {
                    case_id,
                    label_id,
                });
                return data;
            } catch (error) {
                console.log("error>>>", error);
            }
        },
        fetchCaseDueDate: async({ commit }, payload) => {
            const { case_id, params = {} } = payload;

            try {
                const { data } = await axios.get(`sla/${case_id}/case-due-date`, {
                    params,
                });
                commit('SET_CASE_DUE_DATE_DATA', data);
            } catch (error) {
                console.log("error>>>", error);
            }
        },
        fetchEntityDueDate: async({ commit }, payload) => {
            const { case_id, params = {} } = payload;

            try {
                const { data } = await axios.get(`sla/${case_id}/entity`, {
                    params,
                });
                commit('SET_ENTITY_DUE_DATE_DATA', data);
            } catch (error) {
                console.log("error>>>", error);
            }
        },
    },
};